<script>
import config from "@/helpers/config"
import niceFunctions from "@/helpers/niceFunctions"
import MenuUnderline from '@/components/MenuUnderline.vue'
export default {
   components: { MenuUnderline },
  data() {
    return {  
    }
  }, 
  props:['windowScroll'],
  computed: {
    url() { return config.urlToServer }, 
    publicPageColorsDict() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColorsDict : null }, 
    publicPageColors() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColors : null },
    publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : {} },
    tabs() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.tabs : [] },
    availableBookings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.availableBookings : [] },
    openApplications() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.openApplications : [] },
    availableCourses() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.availableCourses : [] },
    instructors() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.instructors : [] },
    customerName() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.customerName : '' },
    settings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.settings : null },
    hasSettings() { return this.settings },
    publicPageImages() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageImages : null },
    publicPageLogo() { return this.publicPageImages != null ?  this.publicPageImages.find(x => x.location == 'logo') : null },
    selectedPage() {
      var page = '';
      if(this.$route.name != undefined)
      {
        return this.$route.name.includes('_') ? this.$route.name.split('_')[1] : this.$route.name;
      }
      return this.$route.name 
    }
  },
  watch:
  {
    customerName(newvalue)
    {
      document.title = newvalue
    },
    publicPageColorsDict(newValue)
    {
        $("body").css({ 'background-color': newValue.background_color.color});
    }
  },
  methods:
  {
    getColor(location)
    {
      return niceFunctions.getColor(this.publicPageColors, location)
    },
    getPageName(page) {
      return niceFunctions.getPageName(page)
    },
    getSelectedStyle(showStyle) {
        return showStyle ?
          niceFunctions.getColor(this.publicPageColors, 'background_color')
         : null;
    }
  }
}
</script>
<template>
  <section class="Menu" v-if="publicPageImages != null" v-fade-in>
    <div class="Menu-logo" v-if="publicPageLogo">
      <img :src="url + 'uploads/' + publicPageLogo.customer_id + '/images/' + publicPageLogo.image_name" style="height: 100%" />
    </div>
    <div class="p" :class="[windowScroll > 200 ? 'Menu-addedWhite' : 'Menu-noBg']">     
        <router-link class="no-link-style"  :to="{ name: getPageName('home'), params: { id: $route.params.id } }">      
          Hem
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'home')"></MenuUnderline>
        </router-link>

        <router-link class="no-link-style"  :to="{ name: getPageName('community'), params: { id: $route.params.id } }">
          {{ hasSettings ? settings.Community.singular : '' }}
           <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'community')"></MenuUnderline>
        </router-link>

        <router-link v-for="tab in tabs" :key="tab.id" class="no-link-style" 
          :to="{ name: getPageName('tab'), params: { id: $route.params.id, tabid: tab.id } }">
          {{ tab.name }}
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'tab' && $route.params.tabid == tab.id)"></MenuUnderline>
        </router-link>

        <router-link v-if="publicPage.include_image_gallery" class="no-link-style"
          :to="{ name: getPageName('imageGallery'), params: { id: $route.params.id } }">
          {{ hasSettings ? settings.ImageGallery.singular : '' }}
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'imageGallery')"></MenuUnderline>
        </router-link>

        <router-link v-if="availableBookings.length == 1 && availableBookings[0].duration_unit == 'Timmar'" class="no-link-style"
          :to="{ name: getPageName('bookingHoursAdd'), params: { id: $route.params.id, bookingid: availableBookings[0].id } }">
          {{ availableBookings[0].name }}
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'bookingHoursAdd')"></MenuUnderline>
        </router-link>

        <router-link v-if="availableBookings.length == 1 && availableBookings[0].duration_unit == 'Dagar'" class="no-link-style"
          :to="{ name: getPageName('bookingDaysAdd'), params: { id: $route.params.id, bookingid: availableBookings[0].id } }">
          {{ availableBookings[0].name }}
        <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'bookingDaysAdd')"></MenuUnderline>
        </router-link>

        <router-link v-if="availableBookings.length > 1" class="no-link-style"
          :to="{ name: getPageName('bookings'), params: { id: $route.params.id } }">
          {{ hasSettings ? settings.BookingItem.plural : '' }}
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'bookings')"></MenuUnderline>
        </router-link>
        
        <router-link v-if="openApplications.length > 0" class="no-link-style"
          :to="{ name: getPageName('applications'), params: { id: $route.params.id } }"
          :style="getSelectedStyle()">
          {{ hasSettings ? settings.OpenApplication.plural : '' }}
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'applications' || selectedPage == 'openApplicationDetails')"></MenuUnderline>
        </router-link>

        <router-link v-if="availableCourses.length > 0" class="no-link-style" 
          :to="{ name: getPageName('courses'), params: { id: $route.params.id } }">
          {{ hasSettings ? settings.Course.plural : '' }}
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'courses' || selectedPage == 'courseDetails')"></MenuUnderline>
        </router-link>

        <router-link v-if="instructors.length > 0"        
          :style="getSelectedStyle(selectedPage == 'instructors' || selectedPage == 'instructorDetails')" class="no-link-style"
          :to="{ name: getPageName('instructors'), params: { id: $route.params.id } }">
          {{ hasSettings ? settings.CourseInstructor.plural : '' }}
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'instructors' || selectedPage == 'instructorDetails')"></MenuUnderline>
        </router-link>
       
        <router-link v-if="publicPage.include_contact" class="no-link-style"
          :to="{ name: getPageName('contact'), params: { id: $route.params.id } }">
          Kontakt
          <MenuUnderline :backgroundColor="getSelectedStyle(selectedPage == 'contact')"></MenuUnderline>
        </router-link>
      
    </div>
  </section>
</template>

<style scoped>
.Menu
{
  width:100%; 
  max-width: 1980px;
  height: 110px; 
  color: white;
  position: fixed;
  top:0px;
  z-index: 20; 
  font-family: 'Raleway', sans-serif;
  text-transform: capitalize;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

a, a:hover {
  text-decoration: none;
}

.p {
  display:flex;
  justify-content: center;
 align-items: center;

}
.Menu-addedWhite
{
  background: rgba(255,255,255,0.97);
  border-bottom: 1px solid #ccc;
  transition: 0.3s;
}
.Menu-noBg
{
  background: none;
  transition: 0.3s;
}

.Menu-logo {
  height: 70px; position: absolute; top: 0px; left: 0px;
}

.no-link-style {
  font-size: 1.2vw;
  color: inherit;
  font-weight: 600;
  padding: 23px 2vw;
  position: relative;
}

@media (-webkit-device-pixel-ratio: 1.25) {
  .no-link-style {
    /* padding: 20px 25px; */
    /* font-size: 11pt; */
    /* vertical-align: center; */
  }

  .Menu-logo {
    /* height: 52px; */
  }
} 


@media only screen and (min-width: 1600px) {
  .no-link-style {
    font-size: 14pt;
    /* padding: 26px 30px; */
  }
}

@media only screen and (min-width: 1980px) {
  .no-link-style {

  padding: 0px 30px 10px 30px;
 
}
}
</style>
